var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 32 32",
        fill: _vm.color,
      },
    },
    [
      _c("title", [_vm._v("person")]),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M20.693 8.667c0-2.573-2.12-4.693-4.693-4.693s-4.693 2.12-4.693 4.693c0 2.573 2.12 4.693 4.693 4.693s4.693-2.12 4.693-4.693zM23.333 8.667c0 4.031-3.302 7.333-7.333 7.333s-7.333-3.302-7.333-7.333c0-4.031 3.302-7.333 7.333-7.333s7.333 3.302 7.333 7.333zM16 28.027c2.743 0 5.893-0.354 8.257-1.196 2.498-0.89 3.016-1.859 3.035-2.521-0.014-0.043-0.089-0.253-0.434-0.623-0.466-0.499-1.244-1.082-2.341-1.642-2.189-1.116-5.26-1.937-8.517-1.937s-6.329 0.821-8.517 1.937c-1.097 0.559-1.875 1.143-2.341 1.642-0.345 0.37-0.42 0.58-0.434 0.623 0.019 0.662 0.538 1.631 3.035 2.521 2.364 0.843 5.514 1.196 8.257 1.196zM16 30.667c-5.806 0-13.933-1.467-13.933-6.396 0-3.137 6.6-6.804 13.933-6.804s13.933 3.667 13.933 6.804c0 4.93-8.128 6.396-13.933 6.396z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }